import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SmartContractViewService } from "../smart-contract-view.service";
import { SmartContractOperationService } from "../../smart-contract-operation/smart-contract-operation.service";
import { FabricChaincode } from "@aptsi-types";
import { KeycloakStateService } from "src/app/core/service/utility.service";
import { MatDialog } from "@angular/material/dialog";
import { UnauthorizedDialogComponent } from "../../shared/dialogs/unauthorized-dialog/unauthorized-dialog.component";

@Component({
  selector: 'app-smart-contract-view-keys',
  templateUrl: './smart-contract-view-keys.component.html',
  styleUrls: ['smart-contract-view-keys.component.scss']
})
export class SmartContractViewKeysComponent implements OnInit {

  chaincodeId!: string;
  keys: any[] = [];
  searchedData: FabricChaincode[] = [];


  channel!: string;
  chaincode!: string;

  searchText: string = '';
  filterByStatus: string = '';
  issearch: boolean = false;

  roles: string[] = [];

  headers = [
    { name: 'Key', property: 'key', showInDropdown: true }
  ];

  buttonConfig =
    { view: true }
    ;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: SmartContractViewService,
    private contractService: SmartContractOperationService,
    private keycloakState: KeycloakStateService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {

    this.keycloakState.observeRealmRoles().subscribe((roles) => {
      this.roles = roles || [];

      if (!this.canAccessView()) {
        this.openUnauthorizedDialog();
        this.router.navigate(['/secure-blockchain/auth-tools/view/search']);
        return;
      }
    });

    this.chaincodeId = this.route.snapshot.paramMap.get('id')!;
    this.loadChaincodeDetails();
  }

  canAccessView(): boolean {
    return this.roles.includes('smart_contract_viewer')
  }

  loadChaincodeDetails() {
    this.contractService.getContractById(this.chaincodeId)
      .subscribe((data: any) => {

        if (!data) {
          alert("Chaincode not found");
          return;
        }

        this.channel = data.channelName;
        this.chaincode = data.chaincodeName;

        this.loadKeys();
      });
  }

  loadKeys(): void {
    this.service.getKeys(this.channel, this.chaincode)
      .subscribe((res: any[]) => {

        // API returns string array → convert to table format
        this.keys = res.map(k => ({ key: k }));
      });
  }

  handleAction(event: any): void {
    const key = event.rowData.key;

    if (event.action === "View") {
      this.router.navigate(
        ['/secure-blockchain/auth-tools/view', this.chaincodeId, key],
        {
          state: {
            channel: this.channel,
            chaincode: this.chaincode
          }
        }
      );
    }
  }
  onSearchTextChange(): void {
    if (!this.searchText) {
      this.issearch = false;
      return;
    }

    this.issearch = true;

    this.service.searchContracts(1, this.searchText, this.filterByStatus, this.keycloakState.getOrganizationId())
      .subscribe((res: any[]) => {
        this.searchedData = res;
      });
  }

  back(): void {
    this.router.navigate(['/secure-blockchain/auth-tools/view/search']);
  }


  openUnauthorizedDialog(): void {
    const dialogRef = this.dialog.open(UnauthorizedDialogComponent, {
      width: "300px"
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/secure-blockchain/auth-tools']);
    });
  }
}